import React, { useContext, useEffect, useState } from 'react';
import apiClient from '../../services/api/apiClient.js';
import { AuthContext } from '../../contexts/AuthContext.jsx';
import { formatMoney } from '../finanzas-cxp/shared.js';

/**
 * V1: `IbuFront/src/components/views/Reportes/ReporteUtilidades.jsx`, gateada (en el
 * JSX real de V1) por `user.contenedoresReporte` -> `contenedores:reporte` -- se
 * preserva ese mismo flag para no cambiar quién puede ver la pantalla respecto de V1.
 * No es una tabla: es un resumen de una sola fila por concepto (Cuentas por Cobrar,
 * Saldo en Bancos, Retiros, Cuentas por Pagar, Utilidad), calcado del `<Table>` fijo
 * de V1. Backend nuevo: `GET /reportes/utilidad`, ver
 * `reportes-extra.service.js#utilidad` (incluye el hardcode de 2 bancos excluidos que
 * V1 ya tenía -- ver comentario ahí y DUDAS.md).
 */
export default function ReporteUtilidadPage() {
  const { hasPermiso } = useContext(AuthContext);
  const puedeVer = hasPermiso('contenedores:reporte');

  const [resumen, setResumen] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!puedeVer) return;
    setCargando(true);
    setError(null);
    apiClient
      .get('/reportes/utilidad')
      .then(({ data }) => setResumen(data.data))
      .catch((e) => { setError(e.message); setResumen(null); })
      .finally(() => setCargando(false));
  }, [puedeVer]);

  if (!puedeVer) return <div className="text-slate-500">No tienes permiso para ver este módulo.</div>;

  const filas = resumen ? [
    { label: 'Cuentas Por Cobrar', valor: resumen.cuentasPorCobrar },
    { label: 'Saldo en Bancos', valor: resumen.saldoBancos },
    { label: 'Retiros', valor: resumen.retiros },
    { label: 'Cuentas Por Pagar', valor: resumen.cuentasPorPagar },
  ] : [];

  return (
    <div className="space-y-4 max-w-xl">
      <h1 className="text-xl font-semibold text-slate-900">Reporte Utilidad</h1>

      {error && <p className="text-sm text-danger-600">{error}</p>}
      {cargando && <p className="text-sm text-slate-400">Cargando...</p>}

      {!cargando && resumen && (
        <div className="card overflow-hidden">
          <table className="min-w-full text-sm">
            <tbody className="divide-y divide-slate-100">
              {filas.map((f) => (
                <tr key={f.label}>
                  <th className="px-3 py-2 text-left font-medium text-slate-600 w-1/2">{f.label}</th>
                  <td className="px-3 py-2 text-right">{formatMoney(f.valor)}</td>
                </tr>
              ))}
              <tr className="bg-slate-50 font-semibold">
                <th className="px-3 py-2 text-left text-slate-900">Utilidad</th>
                <td className="px-3 py-2 text-right text-slate-900">{formatMoney(resumen.utilidad)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
